__turbopack_context__.v({
  "offerTileMenuButton": "VlSVga_offerTileMenuButton",
  "offerTileMenuWrapper": "VlSVga_offerTileMenuWrapper",
});
